import { createSlice } from '@reduxjs/toolkit';
import { addNewBulk } from './bulkUploadService';

const initialState = {
  newBulk: {
    isBulkCreating: null,
    isBulkCreated: null,
    bulkCreationMsg: null,
  },
};

const bulkUploadSlice = createSlice({
  name: 'bulk',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
      //Bulk creating
    builder
      .addCase(addNewBulk.pending, (state) => {
        state.newBulk = {
          ...initialState.newBulk, // Reset to initial state
          isBulkCreating: true,
          bulkCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewBulk.rejected, (state, action) => {
        state.newBulk = {
          ...initialState.newBulk,
          isBulkCreating: false,
          isBulkCreated: false,
          bulkCreationMsg: action.payload || 'Error occurred while creating the bulk.',
        };
      })

      // FULFILLED
      .addCase(addNewBulk.fulfilled, (state, action) => {
        state.newBulk = {
          ...initialState.newBulk,
          isBulkCreating: false,
          isBulkCreated: true,
          bulkCreationMsg: action.payload || 'Successfully created the bulk.',
        };
      });
  },
});

export default bulkUploadSlice.reducer;
